'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

var _advancedFetch = _interopRequireDefault(require("../advanced-fetch"));

var _mainNavigation = _interopRequireDefault(require("../main-navigation"));

var _metadata = _interopRequireDefault(require("../../lib/metadata"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Navigation = /*#__PURE__*/function (_React$Component) {
  _inherits(Navigation, _React$Component);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));
    _this.changeLanguage = _this.changeLanguage.bind(_assertThisInitialized(_this));
    _this.state = {
      overlayStyle: 'overlay-closed'
    };
    _this.navToggle = _this.navToggle.bind(_assertThisInitialized(_this));
    _this.navCloseIfvisible = _this.navCloseIfvisible.bind(_assertThisInitialized(_this));
    _this.stickyRef = null;
    return _this;
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t,
          theme = document.body.classList.item(0);
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-navigation nav-wrapper' + (this.props.hasSearched ? ' nav-has-searched ' : '')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "top-bar",
        ref: function ref(el) {
          return _this2.stickyRef = el;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'top-bar-left'
      }, this.props.alwaysLinkExternal ? this.props.hasSearched ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
        href: t("backlink ".concat(theme)),
        className: 'go-back-link'
      }), /*#__PURE__*/_react.default.createElement("img", {
        className: "header-logo has-searched" //eslint-disable-next-line
        ,
        src: "/static/assets/images/logos/".concat(this.props.theme, "/logo-").concat(this.props.i18n.language, ".png")
      })) : /*#__PURE__*/_react.default.createElement("a", {
        href: t("backlink ".concat(theme))
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "header-logo no-has-searched" //eslint-disable-next-line
        ,
        src: "/static/assets/images/logos/".concat(this.props.theme, "/logo-").concat(this.props.i18n.language, ".png")
      })) : this.props.hasSearched ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
        onClick: this.props.goBack,
        className: 'go-back-link'
      }), /*#__PURE__*/_react.default.createElement("img", {
        className: "header-logo has-searched" //eslint-disable-next-line
        ,
        src: "/static/assets/images/logos/".concat(this.props.theme, "/logo-").concat(this.props.i18n.language, ".png")
      })) : /*#__PURE__*/_react.default.createElement("a", {
        href: t("backlink ".concat(theme))
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "header-logo no-has-searched" //eslint-disable-next-line
        ,
        src: "/static/assets/images/logos/".concat(this.props.theme, "/logo-").concat(this.props.i18n.language, ".png")
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: this.state.overlayStyle,
        onClick: this.navCloseIfvisible
      }))), /*#__PURE__*/_react.default.createElement(_mainNavigation.default, {
        t: this.props.t,
        activeLanguage: this.props.i18n.language,
        changeLanguage: function changeLanguage(e, language) {
          return _this2.changeLanguage(e, language, theme);
        },
        closeNavigation: this.navCloseIfvisible,
        theme: theme,
        history: this.props.history,
        languages: this.props.i18n.options.locales
      }));
    }
  }, {
    key: "navCloseIfvisible",
    value: function navCloseIfvisible() {
      if (document.body.classList.contains('nav-open')) {
        document.body.classList.remove('nav-open');
      }

      this.setState({
        overlayStyle: 'overlay-closed'
      });
    }
  }, {
    key: "navToggle",
    value: function navToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        overlayStyle: 'overlay-open'
      });
      document.body.classList.toggle('nav-open');
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(e, language, theme) {
      var _this3 = this;

      e.preventDefault();
      (0, _advancedFetch.default)('/api/change-language', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lang: language
        })
      }).then(function () {
        var _this3$props = _this3.props,
            i18n = _this3$props.i18n,
            t = _this3$props.t,
            history = _this3$props.history;
        i18n.changeLanguage(language, function (err) {
          if (err) void 0;
          (0, _metadata.default)(t("".concat(theme, " | Hofsuche")), t("".concat(theme, " | metadescription")));
          var pathArray = history.location.pathname.split('/');
          pathArray[1] = language;
          history.push(pathArray.join('/'));
        });
      });
    }
  }]);

  return Navigation;
}(_react.default.Component);

Navigation.propTypes = {
  t: _propTypes.default.func.isRequired,
  theme: _propTypes.default.string,
  menu: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    onclick: _propTypes.default.func,
    link: _propTypes.default.string.isRequired,
    active: _propTypes.default.bool
  })),
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    changeLanguage: _propTypes.default.func,
    options: _propTypes.default.shape({
      locales: _propTypes.default.arrayOf(_propTypes.default.string)
    })
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string
    })
  }),
  alwaysLinkExternal: _propTypes.default.bool,
  hasSearched: _propTypes.default.bool,
  goBack: _propTypes.default.func
};

var _default = (0, _translate.default)(Navigation);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/navigation/index.js
// module id = 335
// module chunks = 0